export type Event = {
  id: number;
  owner_type: string;
  owner_id: number;
  type: string;
  description: string;
  created_date: string;
  updated_date: string;
};

export const en = {
  id: 1,
  owner_type: 2,
  owner_id: 3,
  created_date: 6,
  updated_date: 7
}

export const EVENT_TYPE = {
  PUMP_MOTO_STATE_CHANGE: "PumpMotoStateChange",
  REMOTE_CONTROL_CHANGE: "RemoteControlChangeEvent"
}

export const OWNER_TYPE = {
  PUMP: "pump",
  PUMP_MOTO: "pump_moto",
  REMOTE_CONTROL: "remote_control"
}
